import { SanityBlock } from 'sanity-codegen'

import {
  TypographyRebrand,
  TypographyRebrandProps
} from 'src/components/atoms/TypographyRebrand'
import { Text } from 'src/components/molecules/sanity/Content'

type HeroTitle = SanityBlock[] | string

type HeroTitleTypographyProps = {
  title: HeroTitle
  variant: TypographyRebrandProps['variant']
}

const HeroTitleTypography = ({ title, variant }: HeroTitleTypographyProps) => {
  return (
    <TypographyRebrand variant={variant}>
      {typeof title === 'string' ? (
        title
      ) : (
        <Text
          components={{
            block: ({ children }) => <span className='block'>{children}</span>
          }}
          value={title}
        />
      )}
    </TypographyRebrand>
  )
}

export { HeroTitleTypography }
export type { HeroTitle }
